import script from "./ImageStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./ImageStylePanel.vue?vue&type=style&index=0&id=e8d702d2&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d702d2"]])

export default __exports__